// Display-only relabel for older stored names; raw values stay untouched.
const LEGACY = [
  [/Profile Positioning Services/gi, "Account History Positioning"],
  [/Grant Readiness and Funding Research/gi, "Grant Readiness & Research"],
  [/Business Foundation and Entity Setup/gi, "Business Foundation Setup"],
  [/\bTradelines\b/g, "Accounts"],
  [/\bTradeline\b/g, "Account"],
  [/\btradelines\b/g, "accounts"],
  [/\btradeline\b/g, "account"],
];

export const relabel = (value) => {
  if (typeof value !== "string") return value;
  return LEGACY.reduce((s, [re, to]) => s.replace(re, to), value);
};
